import { Table } from 'antd';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { encrypt } from '../../../../Utils/CryptoHelper';

const COASample = ({ dataSource }) => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (Array.isArray(dataSource) && dataSource.length > 0) {
      const groupedData = groupByRFNumber(dataSource);
      setData(groupedData);
    } else {
      setData([]);
    }
    setIsLoading(false);
  }, [dataSource]);

  const groupByRFNumber = (source) => {
    const grouped = {};

    source.forEach((item) => {
      const rfNumber = item.RFNumber;

      if (!grouped[rfNumber]) {
        grouped[rfNumber] = {
          RFNumber: rfNumber,
          Sample: [],
        };
      }

      grouped[rfNumber].Sample.push(item);
    });

    return Object.values(grouped);
  };

  const columns = [
    {
      key: 'RFNumber',
      title: 'RF Number',
      dataIndex: 'RFNumber',
      sorter: (a, b) => a.RFNumber.localeCompare(b.RFNumber),
    },
  ];

  return (
    <Table
      columns={columns}
      dataSource={data}
      loading={isLoading}
      rowKey={(record) => record.RFNumber}
      expandable={{
        expandedRowRender: (record) => <ExpandedRow record={record} />,
      }}
      scroll={{ x: 'max-content' }}
    />
  );
};

export default COASample;

// Komponen terpisah untuk expandable row
const ExpandedRow = ({ record }) => {
  const dataSample = record.Sample;

  const columnSample = [
    {
      key: 'SampleNumber',
      title: 'Sample Number',
      dataIndex: 'SampleNumber',
      sorter: (a, b) => a.SampleNumber.localeCompare(b.SampleNumber),
      render: (value, record) => (
        <Link
          to={`/dashboard/menuorder/sample/${encodeURIComponent(encrypt(record.AccountId))}/${encodeURIComponent(encrypt(record.SampleCode))}`}
          className="text-second hover:text-second-600 font-medium"
        >
          {value}
        </Link>
      ),
    },
    {
      key: 'SampleName',
      title: 'Sample Name',
      dataIndex: 'SampleName',
      sorter: (a, b) => a.SampleName.localeCompare(b.SampleName),
    },
    {
      key: 'ReportNumber',
      title: 'Report Number',
      dataIndex: 'ReportNumber',
      sorter: (a, b) => a.ReportNumber.localeCompare(b.ReportNumber),
    },
    {
      key: 'COADueDate',
      title: 'COA Due Date',
      dataIndex: 'COADueDate',
      sorter: (a, b) => a.COADueDate.localeCompare(b.COADueDate),
    },
    {
      key: 'ServiceType',
      title: 'Service Type',
      dataIndex: 'ServiceType',
      sorter: (a, b) => a.ServiceType.localeCompare(b.ServiceType),
      render: (value) => <p>{value || '-'}</p>,
    },
  ];

  return (
    <Table
      columns={columnSample}
      dataSource={dataSample}
      rowKey={(record) => record.SampleCode}
      pagination={false}
      scroll={{ x: 'max-content' }}
    />
  );
};
